const VERSION = 1;
const PREFIX = 'line-medic:ics214:v1';

function memberKey(memberId) {
  const id = String(memberId || (typeof window !== 'undefined' ? window.__SMFD_MEMBER_ID__ : '') || 'member').trim() || 'member';
  return `${PREFIX}:${id}`;
}

export function make214Id(prefix = '214') {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function empty214State() {
  return { version: VERSION, incidents: [], updatedAt: '' };
}

export function load214State(memberId) {
  try {
    const raw = localStorage.getItem(memberKey(memberId));
    if (!raw) return empty214State();
    const parsed = JSON.parse(raw);
    return {
      version: VERSION,
      incidents: Array.isArray(parsed?.incidents) ? parsed.incidents : [],
      updatedAt: String(parsed?.updatedAt || ''),
    };
  } catch (_) {
    return empty214State();
  }
}

export function save214State(memberId, state) {
  const next = {
    version: VERSION,
    incidents: Array.isArray(state?.incidents) ? state.incidents : [],
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(memberKey(memberId), JSON.stringify(next));
  return next;
}

export function formatIncidentDisplay(incident) {
  const name = String(incident?.name || '').trim();
  const order = String(incident?.incidentOrderNumber || '').trim();
  return order ? `${name} - ${order}` : name;
}

export function normalizeIncident(input = {}) {
  const now = new Date().toISOString();
  return {
    id: String(input.id || make214Id('incident')),
    name: String(input.name || input.incident || '').trim(),
    incidentOrderNumber: String(input.incidentOrderNumber || '').trim().toUpperCase(),
    incidentIrwinId: String(input.incidentIrwinId || input.irwinId || '').trim(),
    incidentSource: String(input.incidentSource || input.source || '').trim(),
    medlEmail: String(input.medlEmail || '').trim().toLowerCase(),
    createdAt: String(input.createdAt || now),
    updatedAt: now,
    dailies: Array.isArray(input.dailies) ? input.dailies : [],
  };
}

export function latestDaily(incident) {
  return [...(incident?.dailies || [])]
    .sort((a, b) => Date.parse(b?.createdAt || b?.updatedAt || '') - Date.parse(a?.createdAt || a?.updatedAt || ''))[0] || null;
}

export function localDateInput(date = new Date()) {
  const adjusted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return adjusted.toISOString().slice(0, 10);
}

export function localTimeInput(date = new Date()) {
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

function defaultHomeAgency(profile, prior) {
  const memberKind = String(profile?.member_kind || '').trim().toLowerCase();
  const email = String(profile?.email || '').trim().toLowerCase();
  const organization = [
    profile?.home_agency,
    profile?.agency,
    profile?.organization_name,
    profile?.tenant_name,
  ].filter(Boolean).join(' ').toLowerCase();

  const isSacMetroMember = email.endsWith('@metrofire.ca.gov')
    || ['rems_temporary', 'rems_permanent'].includes(memberKind)
    || /sacramento metropolitan|sac metro|metro fire/.test(organization);

  if (isSacMetroMember) return 'CA-SAC';

  return String(
    prior?.homeAgency
    || profile?.home_agency
    || profile?.agency
    || profile?.organization_name
    || profile?.tenant_name
    || ''
  ).trim();
}

export function defaultDaily({ profile, prior } = {}) {
  const now = new Date();
  const position = '';
  const homeAgency = defaultHomeAgency(profile, prior);

  return {
    id: make214Id('daily'),
    opLabel: '',
    fromDate: localDateInput(now),
    fromTime: '07:00',
    toDate: localDateInput(now),
    toTime: '19:00',
    name: String(profile?.full_name || '').trim(),
    icsPosition: position,
    homeAgency,
    resources: [],
    headerLocked: false,
    activities: [],
    createdAt: now.toISOString(),
    updatedAt: now.toISOString(),
    lastEmailedAt: '',
    lastEmailTo: '',
    lastEmailSubject: '',
    signatureStrokes: [],
    signedAt: '',
  };
}
